// Landningssidevarianter för kampanj-inbjudningar (/i/[inviteCode]).
//
// Varje nyckel motsvarar ett `landingVariant`-värde på ett dokument i Firestore
// collection `/codes`. Metadata på koden avgör enbart vilken variant som visas –
// ingen validering görs vid variantvalet (se getLandingVariant Cloud Function).
//
// Lägg till en ny variant genom att bara lägga till en nyckel här – logiken för
// hur sidan väljer variant behöver inte ändras.

export const DEFAULT_LANDING_VARIANT = 'buyer_default';

// Vän-läge (mode === 'friend') använder denna variant för copy/bild.
export const FRIEND_LANDING_VARIANT = 'buyer_demand_v1';

export const LANDING_VARIANTS = {
  buyer_default: {
    pill: 'Du har fått en exklusiv inbjudan ✨',
    heading: 'Agera innan bostäderna når marknaden',
    subheading: 'Hela marknaden – och det som händer före den.',
    explainer: 'Bostäder till salu idag, plus bostäder du kan agera på innan de når marknaden.',
    aboveCta: 'Platserna är begränsade – säkra din innan de tar slut.',
    aboveCtaHighlight: 'begränsade', // ord som färgas amber (#F59E0B)
    cta: 'Säkra din plats',
    // Steg 2 (GetInvited)
    step2Heading: 'Ange ditt telefonnummer',
    step2Subheading: 'Används för inloggning.',
    step2Cta: 'Lås upp min inbjudan',
  },
  seller_demand_v1: {
    pill: 'Förhandsaccess till efterfrågan ✨',
    heading: 'Förstå efterfrågan innan du säljer',
    subheading: 'Följ intresset för din bostad – och fatta bättre beslut om när du säljer.',
    explainer: 'Se hur efterfrågan utvecklas över tid och fatta mer informerade beslut om när du ska sälja.',
    aboveCta: 'Platserna är begränsade – säkra din innan de tar slut.',
    aboveCtaHighlight: 'begränsade',
    cta: 'Se efterfrågan på din bostad',
    // Steg 2 (GetInvited)
    step2Heading: 'Se efterfrågan på din bostad',
    step2Subheading: 'Ange ditt telefonnummer för att skapa ditt konto.',
    step2Cta: 'Se efterfrågan på min bostad',
  },
  buyer_demand_v1: {
    pill: 'Förhandsaccess till bostäder ✨',
    heading: 'Agera innan bostäderna når marknaden',
    subheading: 'Upptäck bostäder till salu idag – och innan de når marknaden.',
    // Ingen explainer/aboveCta/aboveCtaHighlight – renderas aldrig för preview-varianter.
    cta: 'Hitta bostäder före marknaden',
    // Steg 2 (GetInvited)
    step2Heading: 'Hitta bostäder före marknaden',
    step2Subheading: 'Ange ditt telefonnummer för att skapa ditt konto.',
    step2Cta: 'Hitta bostäder före marknaden',
  },
};

// Fallback-säker: okänd/saknad nyckel → buyer_default.
export const getLandingVariant = (key) =>
  LANDING_VARIANTS[key] || LANDING_VARIANTS[DEFAULT_LANDING_VARIANT];
